/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type FormWorkflowStatus = typeof FormWorkflowStatus[keyof typeof FormWorkflowStatus];


export const FormWorkflowStatus = {
  AwaitingClinician: 'AwaitingClinician',
  AwaitingPatient: 'AwaitingPatient',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
} as const;
